import React from 'react';
import { List } from 'antd';
import { CopyableInput } from '../../../CopyableInput';

import '../style.scss';

export interface CopyLinkViewProps {
  url: string;
  title: string;
}

export const CopyLinkView: React.FC<CopyLinkViewProps> = React.memo(
  function CopyLink({ title, url }) {
    return (
      <List.Item>
        <List.Item.Meta
          title={<span className="card-link-item-description">{title}</span>}
          description={<CopyableInput value={url} disabled />}
        />
      </List.Item>
    );
  },
);
